<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  configurations.id
                    ? "Editar Configurações de Reserva"
                    : "Cadastrar Configurações de Reserva"
                }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="limit_reservation"
                          ><span class="required">*</span> Empresa:
                        </label>
                        <v-select
                          :options="companies"
                          label="company_name"
                          :reduce="(companies) => companies.id"
                          class="style-chooser"
                          v-model="configurations.company_id"
                        >
                          <div slot="no-options">Carregando...</div>
                        </v-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="limit_reservation">
                          <span class="required">*</span> Limite de reservas em
                          aberto por usuário padrão:
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="configurations.limit_reservation"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="limit_reservation">
                          <span class="required">*</span> Limite de reservas em
                          aberto por usuário gestor:
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="configurations.limit_reservation_manager"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="time_cancel">
                          <span class="required">*</span> Tempo limite para
                          cancelamento automático da reserva em caso de no-show
                          (Em minutos):
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="configurations.time_cancel"
                        />
                      </div>
                      <div class="alert alert-primary col-md-10" role="alert">
                        Exemplo: 60 = 1 hora, 120 = 2 horas.
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> Deseja exibir ícone de
                        posição de trabalho?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch1"
                          v-model="configurations.select_chair"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch1"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo exibirá o icone
                        <i class="fas fa-chair"></i>, se inativo exibirá apenas
                        o nome da posiçao!
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> Deseja forçar o filtro
                        de posições?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch2"
                          v-model="configurations.force_filter"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch2"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo o sistema forçará o usuário a filtrar as
                        posições de trabalho com base em seus adicionais no APP.
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> Deseja exibir o botão de
                        Check-In na Estação de Trabalho na WEB?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch3"
                          v-model="configurations.select_button"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch3"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo exibirá o botão de Check-In na Estação de
                        Trabalho na WEB
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> Deseja exibir o botão de
                        Check-In na Sala de Reunião na WEB?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch5"
                          v-model="configurations.select_button_room"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch5"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo exibirá o botão de Check-In na Sala de Reunião
                        na WEB
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="minimal_hour_to_checkin">
                          <span class="required">*</span> Mínimo de horas para
                          realizar checkin antecipado na estação de trabalho(Em
                          minutos):
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="configurations.minimal_hour_to_checkin"
                        />
                      </div>
                      <div class="alert alert-primary col-md-10" role="alert">
                        Exemplo: 60 = 1 hora, 120 = 2 horas.
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="minimal_hour_to_checkin_room">
                          <span class="required">*</span> Mínimo de horas para
                          realizar checkin antecipado na sala de reunião(Em
                          minutos):
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="configurations.minimal_hour_to_checkin_room"
                        />
                      </div>
                      <div class="alert alert-primary col-md-10" role="alert">
                        Exemplo: 60 = 1 hora, 120 = 2 horas.
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> O Check-In na Estação de
                        Trabalho será obrigatório?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch4"
                          v-model="configurations.able_checkin"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch4"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo Check-In na Estação de Trabalho será
                        obrigatório
                      </div>
                    </div>
                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> O Check-In na Sala de
                        Reunião será obrigatório?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch6"
                          v-model="configurations.able_checkin_room"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch6"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo Check-In na Sala de Reunião será obrigatório
                      </div>
                    </div>

                    <div class="col mt-6">
                      <label for="select_chair">
                        <span class="required">*</span> O Check-In pelo DESKTOP
                        será habilitado?:
                      </label>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch7"
                          v-model="configurations.check_in_desktop"
                        />
                        <label
                          class="custom-control-label"
                          for="customSwitch7"
                        ></label>
                      </div>
                      <div class="alert alert-primary col-md-5" role="alert">
                        Se ativo o Check-In será habilitado somente pelo QRCode
                      </div>
                    </div>

                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/configurations" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      configurations: {
        limit_reservation: "",
        time_cancel: "",
        select_chair: "",
        force_filter: "",
        company_id: "",
        select_button: "",
        select_button_room: "",
        minimal_hour_to_checkin: "",
        able_checkin: "",
        able_checkin_room: "",
        limit_reservation_manager: "",
        check_in_desktop: "",
        minimal_hour_to_checkin_room: "",
      },
      companies: [],
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("limit_reservation", self.configurations.limit_reservation);
      fd.append("time_cancel", self.configurations.time_cancel);
      fd.append("select_chair", self.configurations.select_chair);
      fd.append("force_filter", self.configurations.force_filter);
      fd.append("select_button", self.configurations.select_button);
      fd.append("select_button_room", self.configurations.select_button_room);
      fd.append("able_checkin", self.configurations.able_checkin);
      fd.append("able_checkin_room", self.configurations.able_checkin_room);
      fd.append(
        "minimal_hour_to_checkin",
        self.configurations.minimal_hour_to_checkin
      );
      fd.append("company_id", self.configurations.company_id);
      fd.append(
        "limit_reservation_manager",
        self.configurations.limit_reservation_manager
      );
      fd.append("check_in_desktop", self.configurations.check_in_desktop);
      fd.append(
        "minimal_hour_to_checkin_room",
        self.configurations.minimal_hour_to_checkin_room
      );

      if (self.configurations.id) {
        fd.append("id", self.configurations.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "configurations";

      let fd = self.makeFormData();

      if (self.configurations.id) {
        api += "/" + self.configurations.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/configurations");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getConfigurations: function (id) {
      const self = this;
      const api = self.$store.state.api + "configurations/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.configurations = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    self.getCompanies();
    if (id) {
      self.getConfigurations(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Configurations/Add.vue